



















































































































import {Component, Prop, PropSync, Watch} from 'vue-property-decorator'
import BaseFilter from "@/components/Filter/BaseFilter";
import {PriorityRuleFilter} from "@/store/settings/priority_rules/types";
import {SelectWings, ToggleWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {MsgTransports} from "@/store/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {TransportItem} from "@/store/transport/types";

@Component({components: {SelectWings, ToggleWings}})
export default class PriorityRulesFilter extends BaseFilter<PriorityRuleFilter>{
  @PropSync('filterProp') filterParent!: any;
  @PropSync('runFilter') run!: any;
  @PropSync('show') is_show!: boolean;

  @Getter("priorityList") priorityList: any;
  @Getter("smsTemplates") smsTemplatesList: any;
  @Getter("transports") transportsList: any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action("getPriorityRules") actionGetPriorityRules: any;
  @Action("getTransports") actionGetTransports: any;

  defaultFilter(): PriorityRuleFilter {
    return {
      channel: undefined,
      originator: undefined,
      partner: undefined,
      template: undefined,
      page_number: 1,
      template_priority: undefined,
    };
  }

  partnersList: any = []
  originatorsList: any = []
  templatesList:  any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({transport: this.selectedTransport, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    let newFilter = this.filter.partner ? {partner: this.filter.partner, ...filter} : filter
    const items = await this.actionGetOriginators(newFilter);
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getTemplatesList(filter: any) {
    let newFilter = { is_active: 1, partner: this.filter.partner, ...filter };
    const items = await this.actionGetTemplates({transport: this.selectedTransport, filter: newFilter});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  get selectedTransport(): string | undefined {
    return this.transportsList.find((t: TransportItem) => t.name === this.filter.channel)?.name;
  }

  async created() {
    await this.filtered();
    this.actionGetTransports();
    this.filtered();
    this.scroll();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "The rule for changing the priority of sending",
        addititional_info: getTranslatedParams(this.filter)
      };
      const resp = await this.actionGetPriorityRules(this.filter);
      await this.actionLog(this.logObject);
      this.is_last = resp.length == 0;
    }
    catch (err){
      await this.actionLog({...this.logObject, action_status: "failed"});
    }
  }

  @Watch('filter.partner')
  onPartnerChanged(val?: string, oldVal?: string) {
    if (val) {
      this.actionGetTemplates({transport: this.selectedTransport, is_active:1, partner: val});
    }
    if ((oldVal && val !== oldVal) || !val) {
      this.unsetFilter('template');
      this.unsetFilter('originator');
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: PriorityRuleFilter) {
    this.filterParent = val;
  }

  @Watch('run')
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.run = false;
  }
}
